import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import HelpTipProvider from "./contexts/HelpTipProvider";
import TopBarHeader from "./layout/header/topbar";
import MenuBarHeader from "./layout/header/menubar";
import AppRoutes from "./routes";
import { AuthContext, CompanyContext } from "./utils/CompanyContext";
import {
  getAgentDashboardOrgProgramsRequest,
  setOrganizationDetail,
  getHelpTipsByModule,
} from "./store/actions";
import "./assets/css/dataTables.bootstrap4.css";
import "./index.css";

function App({ initialData, context, isTeams, ResponseData }) {
  const dispatch = useDispatch();
  const [appSettings, setAppSettings] = useState(null);
  const {
    comapnyGuid,
    varcharemployeeid,
    loggedinuseremail,
    employeeNo,
    username,
    usertype,
    ispracticevisible,
    clientname,
    userfirstname,
    userlastname,
    loginuserlickey,
    loginemptitle,
    showtaskicon,
    showgameicon,
    organization,
    layoutlogo,
    userImage,
    titlerolename,
  } = initialData || {};
  useEffect(() => {
    if (!initialData) return;
    // Save Selection in Store
    dispatch(
      setOrganizationDetail({
        Companyguid: comapnyGuid,
        Organization: organization,
        Loginid: varcharemployeeid,
        Employeeid: varcharemployeeid,
        LoginEmail: loggedinuseremail,
        EmployeeNo: employeeNo,
        titlerolename: titlerolename,
        usertype: usertype,
        varcharemployeeid: varcharemployeeid,
        loginemptitle: loginemptitle,
      }),
    );
    // Fetch initial data
    dispatch(
      getAgentDashboardOrgProgramsRequest({
        companyguid: comapnyGuid,
        loginid: varcharemployeeid,
      }),
    );

    // Fetch Help Tips Data
    dispatch(
      getHelpTipsByModule({
        companyguid: comapnyGuid,
        organization: organization,
        moduleName: "L1Dashboard",
      }),
    );
    // Clean up
    return () => {
      // dispatch(resetData());
    };
  }, [dispatch, initialData]);

  const currentUser = {
    CGUID: comapnyGuid,
    Organization: organization,
    Loginid: varcharemployeeid,
    Employeeid: varcharemployeeid,
    LoginEmail: loggedinuseremail,
    DefaultOrganization: organization,
    ...initialData,
  };
  return (
    <div className="App">
      <CompanyContext.Provider value={{ currentCompanyGuid: comapnyGuid }}>
        <AuthContext.Provider value={currentUser}>
          <HelpTipProvider>
            {/* <TopBarHeader /> */}
            {/* <MenuBarHeader /> */}
            <AppRoutes
              titlerolename={titlerolename}
              initialData={initialData}
            />
          </HelpTipProvider>
        </AuthContext.Provider>
      </CompanyContext.Provider>
    </div>
  );
}

export default App;
